var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgOfficeHomeDownloadIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 26,
    viewBox: "0 0 22 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.885 9.5H15.5V2C15.5 1.175 14.825 0.5 14 0.5H8C7.175 0.5 6.5 1.175 6.5 2V9.5H4.115C2.78 9.5 2.105 11.12 3.05 12.065L9.935 18.95C10.52 19.535 11.465 19.535 12.05 18.95L18.935 12.065C19.88 11.12 19.22 9.5 17.885 9.5ZM0.5 24.5C0.5 25.325 1.175 26 2 26H20C20.825 26 21.5 25.325 21.5 24.5C21.5 23.675 20.825 23 20 23H2C1.175 23 0.5 23.675 0.5 24.5Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOfficeHomeDownloadIcon);
export default __webpack_public_path__ + "static/media/office-home-download-icon.23a87cdfdb31482cd1d7fad4e878d403.svg";
export { ForwardRef as ReactComponent };